import React, { Component } from 'react';
import Gallery from '../components/modal/gallery.js';
import ReadMore from '../components/modal/read-more.js';

class Product extends Component {
    constructor(props) {
        super(props);

        const data = props.data;
        this.state = {
            data: data,
            background: data.background,
            logo: data.logo,
            heading: data.heading,
            readMoreModal: false,
            galleryModal: false,
        };

        this.openReadMoreModal = this.openReadMoreModal.bind(this);
        this.closeReadMoreModal = this.closeReadMoreModal.bind(this);

        this.openGalleryModal = this.openGalleryModal.bind(this);
        this.closeGalleryModal = this.closeGalleryModal.bind(this);
    }

    openReadMoreModal() {
        this.setState({ readMoreModal: true });
    };

    closeReadMoreModal() {
        this.setState({ readMoreModal: false });
    };

    openGalleryModal() {
        this.setState({ galleryModal: true });
    };

    closeGalleryModal() {
        this.setState({ galleryModal: false });
    };

    render() {
        const section = {
            background: `linear-gradient(rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.45)), url(${this.state.background}) no-repeat center center`,
            backgroundSize: 'cover',
            textAlign: 'left',
        };

        const mainContainer = {
            height: 'inherit',
        };

        const logo = {
            height: this.state.logo.height,
        };

        const readMoreModalVisibility = this.state.readMoreModal;
        const galleryModalVisibility = this.state.galleryModal;

        return (
            <div className="section" data-tooltip={this.state.data.name} style={section}>
                <div className="container-fluid p-4" style={mainContainer}>
                    <div className="container container-width p-4">
                        <div className="row pt-4 px-xs-2 px-md-4 pb-2" >
                            <div className="col">
                                <img src={this.state.logo.image} style={logo} alt="logo"/>
                            </div>
                        </div>
                    </div>
                    {
                        readMoreModalVisibility || galleryModalVisibility ? (
                            null
                        ): (
                            <div className="container container-width pt-0 pl-4 pr-4">
                                <div className="row pt-0 px-xs-2 px-md-4" >
                                    <div className="col-xs-8 col-sm-5 col-md-5 col-lg-4">
                                        <h5>{this.state.heading}</h5>
                                    </div>
                                </div>
                                <div className="row py-2" >
                                    <div className="col-xs-8 col-sm-5 col-md-5 col-lg-4 d-flex flex-column align-items-end">
                                        <button className="link-button hidden-sm-down" onClick={this.openReadMoreModal}><h5>read more <span className="right-arrow">→</span></h5></button>
                                        <a className="link-button hidden-sm-up" target="_blank" rel="noopener noreferrer" href={this.state.data.website}><h5>read more <span className="right-arrow">→</span></h5></a>
                                        <button className="link-button" onClick={this.openGalleryModal}><h5>see it for yourself <span className="right-arrow">→</span></h5></button>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
                {
                    readMoreModalVisibility ? (
                        <ReadMore data={this.state.data} clickHandler={this.closeReadMoreModal}/>
                    ): (
                        null
                    )
                }
                {
                    galleryModalVisibility ? (
                        <Gallery data={this.state.data} clickHandler={this.closeGalleryModal}/>
                    ): (
                        null
                    )
                }
            </div>
        );
    }
};

export default Product;



// WEBPACK FOOTER //
// ./src/pages/product.js